import {createContext, useContext} from 'react';

export const aiPromptBoxLayoutContext = createContext<boolean>(false);

export function useIsAiPromptBoxMobile(): boolean {
  return useContext(aiPromptBoxLayoutContext);
}
